var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 72,
    viewBox: "0 0 64 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 72,
    rx: 12,
    fill: "#F3F6F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2398 45.824L32.4958 37.056C33.1784 36.3307 33.7331 35.68 34.1598 35.104C34.5864 34.528 34.8958 33.984 35.0878 33.472C35.2798 32.96 35.3758 32.4373 35.3758 31.904C35.3758 30.9013 35.0451 30.1227 34.3838 29.568C33.7438 28.992 32.9224 28.704 31.9198 28.704C30.8531 28.704 29.9144 28.9707 29.1038 29.504C28.2931 30.0373 27.5678 30.8693 26.9278 32L24.3678 29.888C25.2424 28.3733 26.3198 27.232 27.5998 26.464C28.8798 25.6747 30.3624 25.28 32.0478 25.28C33.4344 25.28 34.6504 25.5573 35.6958 26.112C36.7411 26.6667 37.5518 27.4453 38.1278 28.448C38.7038 29.4293 38.9918 30.5707 38.9918 31.872C38.9918 32.8107 38.8744 33.6533 38.6398 34.4C38.4264 35.1253 38.0531 35.8613 37.5198 36.608C36.9864 37.3333 36.2504 38.1867 35.3118 39.168L28.9758 45.728L24.2398 45.824ZM24.2398 48V45.824L27.4078 44.704H39.4398V48H24.2398Z",
    fill: "#4E5667"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step-2.9f83a7699308424f5421dc425bd4b31f.svg";
export { ForwardRef as ReactComponent };